import Masonry from 'masonry-layout';

let elem = document.querySelectorAll('.masonry');
elem.forEach(item => {
    let msnry = new Masonry( item, {
        // options
        itemSelector: '.masonry__item',
        columnWidth: '.grid-sizer',
        percentPosition: true,
        // gutter: 10
    });
})

// if() {
//     msnry.destroy()
// }